import styled from 'styled-components';
import { VerticalNavItemMixin } from '../../mixins/components/VerticalNavItemMixin';
export var StyledVerticalNavItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledVerticalNavItem",
  componentId: "c11n-8-111-1__sc-1eg5s5q-0"
})(["", ""], VerticalNavItemMixin);